import streetlight.web.ui.viewApp

fun main() {
    console.log("loading streetlight")
    viewApp()
}